import Component from "vue-class-component";
import * as $ from "jquery";
import { SalarieDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieDto";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { VueBase } from "../Controls/VueBase";
import { ParametresInstance } from "../Controls/Parameters";
import { EventBus } from "../Controls/EventBus";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { Location } from "vue-router/types/router";
import moment from "moment";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import ModalDsn from "../modalComponents/modalDsn/modalDsn";
import { DemandeEditionTableauDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeEditionTableauDto";
import ModalFilterListeSalaries from "./modalFilterListeSalaries/modalFilterListeSalaries";
import { CommandeEditionListeSalariesDto } from "../../dto/GenApi.iNotPaie.Dto/CommandeEditionListeSalariesDto";
import { FiltreContratSalarieEnum } from "../../dto/GenApi.iNotPaie.Dto/FiltreContratSalarieEnum";
import { TriListeSalariesEnum } from "../../dto/GenApi.iNotPaie.Dto/TriListeSalariesEnum";
import { ListeSalarieConfiguration } from "../../dto/GenApi.iNotPaie.Dto/ListeSalarieConfiguration";
import { NotificationServiceInstance } from "../../shared/services/notification.service";

@Component({
	components: {
		ModalFilterListeSalaries: require("./modalFilterListeSalaries/modalFilterListeSalaries.vue.html"),
		ModalDsn: require("../modalComponents/modalDsn/modalDsn.vue.html")
	},
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as ListeSalariesComponent);
			vm.fetchData();
		});
	},
	beforeRouteLeave(to, from, next) {
		(this as ListeSalariesComponent).expanded = false;
		next();
	}
})
export default class ListeSalariesComponent extends VueBase {
	public tableau?: DemandeEditionTableauDto = undefined;

	public isModDemarrage = false;
	public salaries: SalarieDto[] = [];
	public salariesFiltred: SalarieDto[] = [];
	public modalDsn?: ModalDsn = undefined;
	public curentOrberColumn = "FullName";
	public orderingDesc = true;
	public colorCache: string[] = ["#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#8e44ad", "#2c3e50", "#f1c40f", "#e67e22", "#e74c3c", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"];
	public dataReady = false;
	public filterName = "";
	public filtreTypeContrat = "EnCours";
	public modeTuilles = false;
	public expanded = false;
	public filterPanel = true;
	public checkboxes = document.getElementById("checkboxes");
	public totalSize = 0;
	public allSelected = false;
	public paieEnable = false;
	public canCreateSalarie = false;

	// Identité
	public NomNaissanceVisible = true;
	public BulletinParMailVisible = true;
	public DateNaissanceVisible = false;

	// Qualifications
	public QualificationVisible = true;
	public LibelleEmploiVisible = true;
	public DateEntreeVisible = true;
	public DateDebutContratVisible = true;
	public DateDepartVisible = true;
	public DateFinPeriodeEssaiVisible = false;
	public DateFinContratVisible = true;
	public DateFinPrevisionnelleCddVisible = false;
	public ConventionCollectiveVisible = true;
	public TempsTravailVisible = true;
	public DateEntreeProfessionVisible = false;

	// Contrats
	public TypeContratVisible = true;
	public RegimeVisible = true;
	public NatureContratVisible = true;
	public ServiceVisible = false;
	public RemunerationVisible = true;
	public CongesVisible = true;
	public MutuelleVisible = true;
	public ResponsableHierarchiqueVisible = true;

	// Règlement
	public ModeReglementVisible = true;

	// Interface
	public userCanDeleteSalarie = false;

	public mounted(): void {
    	EventBus.$on(EventConstants.UTILISATEUR_CHANGED, () => {
    		if (ParametresInstance.utilisateurCourant != undefined && ParametresInstance.utilisateurCourant.ProfilUtilisateur) {
				this.initVariables(ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration);
    			this.initTotalSize();
    		}
    	});
    	EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
    		this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
    		this.isModDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);
    		if (!this.paieEnable) {
				this.modeTuilles = true;
			}
    		this.fetchData();
    	});
    	this.isModDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);
    	this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
    	if (!this.paieEnable) {
			this.modeTuilles = true;
		}

    	if (ParametresInstance.utilisateurCourant != undefined && ParametresInstance.utilisateurCourant.ProfilUtilisateur) {
			this.initVariables(ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration);
    	}

    	this.initTotalSize();
	}

	private initVariables(listeSalarieConfiguration: ListeSalarieConfiguration): void {
		this.modeTuilles = listeSalarieConfiguration.ListeSalarieModeTuile;

		// Identité
		this.NomNaissanceVisible = listeSalarieConfiguration.NomNaissanceVisible;
		this.BulletinParMailVisible = listeSalarieConfiguration.BulletinParMailVisible;
		this.DateNaissanceVisible = listeSalarieConfiguration.DateNaissanceVisible;

		// Qualifications
		this.QualificationVisible = listeSalarieConfiguration.QualificationVisible;
		this.LibelleEmploiVisible = listeSalarieConfiguration.LibelleEmploiVisible;
		this.DateEntreeVisible = listeSalarieConfiguration.DateEntreeVisible;
		this.DateDebutContratVisible = listeSalarieConfiguration.DateDebutContratVisible;
		this.DateDepartVisible = listeSalarieConfiguration.DateDepartVisible;
		this.DateFinPeriodeEssaiVisible = listeSalarieConfiguration.DateFinPeriodeEssaiVisible;
		this.DateFinContratVisible = listeSalarieConfiguration.DateFinContratVisible;
		this.DateFinPrevisionnelleCddVisible = listeSalarieConfiguration.DateFinPrevisionnelleCddVisible;
		this.ConventionCollectiveVisible = listeSalarieConfiguration.ConventionCollectiveVisible;
		this.TempsTravailVisible = listeSalarieConfiguration.TempsTravailVisible;
		this.DateEntreeProfessionVisible = listeSalarieConfiguration.DateEntreeProfessionVisible;

		// Contrats
		this.TypeContratVisible = listeSalarieConfiguration.TypeContratVisible;
		this.RegimeVisible = listeSalarieConfiguration.RegimeVisible;
		this.NatureContratVisible = listeSalarieConfiguration.NatureContratVisible;
		this.ServiceVisible = listeSalarieConfiguration.ServiceVisible;
		this.RemunerationVisible = listeSalarieConfiguration.RemunerationVisible;
		this.CongesVisible = listeSalarieConfiguration.CongesVisible;
		this.MutuelleVisible = listeSalarieConfiguration.MutuelleVisible;
		this.ResponsableHierarchiqueVisible = listeSalarieConfiguration.ResponsableHierarchiqueVisible;

		// Règlement
		this.ModeReglementVisible = listeSalarieConfiguration.ModeReglementVisible;

		// Interface
		this.userCanDeleteSalarie = ParametresInstance.userIsAuthorized([RoleConstants.AdministrateurPST, RoleConstants.Administrateur, RoleConstants.Payeur]);
	}

	public changeModeTuile(modeTuilles: boolean): void {
    	this.modeTuilles = modeTuilles;
    	this.saveProfilUtilisateur();
	}

	public saveProfilUtilisateur(): void {
		if (ParametresInstance.utilisateurCourant != undefined && ParametresInstance.utilisateurCourant.ProfilUtilisateur && ParametresInstance.utilisateurCourant.ProfilUtilisateur.Favoris) {
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.ListeSalarieModeTuile = this.modeTuilles;

			// Identité
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.NomNaissanceVisible = this.NomNaissanceVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.BulletinParMailVisible = this.BulletinParMailVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.DateNaissanceVisible = this.DateNaissanceVisible;

			// Qualifications
    		ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.QualificationVisible = this.QualificationVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.LibelleEmploiVisible = this.LibelleEmploiVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.DateEntreeVisible = this.DateEntreeVisible;
    		ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.DateDebutContratVisible = this.DateDebutContratVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.DateDepartVisible = this.DateDepartVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.DateFinPeriodeEssaiVisible = this.DateFinPeriodeEssaiVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.DateFinContratVisible = this.DateFinContratVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.DateFinPrevisionnelleCddVisible = this.DateFinPrevisionnelleCddVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.ConventionCollectiveVisible = this.ConventionCollectiveVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.TempsTravailVisible = this.TempsTravailVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.DateEntreeProfessionVisible = this.DateEntreeProfessionVisible;

			// Contrats
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.TypeContratVisible = this.TypeContratVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.RegimeVisible = this.RegimeVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.NatureContratVisible = this.NatureContratVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.ServiceVisible = this.ServiceVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.RemunerationVisible = this.RemunerationVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.CongesVisible = this.CongesVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.MutuelleVisible = this.MutuelleVisible;
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.ResponsableHierarchiqueVisible = this.ResponsableHierarchiqueVisible;

			// Règlement
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.ListeSalarieConfiguration.ModeReglementVisible = this.ModeReglementVisible;

    		ServicesFactoryInstance.UtilisateurService.updateProfil(ParametresInstance.utilisateurCourant.ProfilUtilisateur);
    	}
	}

	public clickLien(e: any): void {
    	e.stopPropagation();
	}

	public deleteItem(id: number, fullName: string): void {
    	const modalAlerteAvecCallback: ModalAlerteOptions = new ModalAlerteOptions(
    		{
				message: `Souhaitez-vous vraiment supprimer le salarié "${fullName}" définitivement ?`,
    			callBackYes: () => {
    				// TODO call suppression
    				ServicesFactoryInstance.SalarieService.delete(id, () => {
    					NotificationServiceInstance.SendSuccess("La suppression du salarié s'est déroulée avec succès.");
    					this.fetchData();
    				});
    			},
    			canClose: true,
    			showDialog: true,
    			title: "Suppression de salarié"
    		});
    	EventBus.$emit(EventConstants.MODAL_ALERT, modalAlerteAvecCallback);
	}

	public checkIsModified(location: Location): boolean {
    	return super.checkIsModified(location);
	}

	public fetchData(): void {
    	if (!this.paieEnable) {
			this.modeTuilles = true;
		}

    	this.canCreateSalarie = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]);
    	if (ParametresInstance.societeCourante == undefined || ParametresInstance.societeCourante.Code == undefined) {
			return;
		}
    	this.dataReady = false;
    	ServicesFactoryInstance.SalarieService.getSalaries(data => {
    		this.dataReady = true;
    		this.salaries = data;
    		this.salariesFiltred = this.salaries;
			this.doFilter();
    	});
	}

	public oderBy(columnName: string): void {
    	if (this.curentOrberColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.curentOrberColumn = columnName;
    	this.doOrder();
	}

	public doOrder(): void {
    	const orderingDesc = this.orderingDesc;
    	const columnName = this.curentOrberColumn;
    	if (this.salariesFiltred != undefined) {
    		this.salariesFiltred = this.salariesFiltred.sort(function(a, b) {
    			if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
    			if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

    			return 0;
    		});
    	}
	}

	public doFilter(): void {
    	let d: Date = new Date();

    	if (ParametresInstance.societeCourante != undefined &&
            ParametresInstance.societeCourante.PeriodeActive != undefined) {
			d = new Date(ParametresInstance.societeCourante.PeriodeActive.getUTCFullYear(), ParametresInstance.societeCourante.PeriodeActive.getUTCMonth());
		}

		this.salariesFiltred = this.salaries.filter(s =>
			(
				this.filtreTypeContrat == "Tous" ||
				(this.filtreTypeContrat == "EnCours" && s.DateDebutContrat && (!s.DateFinContrat || moment.utc(s.DateFinContrat).isSameOrAfter(d))) ||
				(this.filtreTypeContrat == "ActifExercice" && (s.DateDernierBulletin && moment.utc(s.DateDernierBulletin).year() == moment.utc(d).year() || !s.DateDernierBulletin && s.DateDebutContrat && moment.utc(s.DateDebutContrat).year() == moment.utc(d).year()) && (s.DateFinContrat == null || moment.utc(s.DateFinContrat).year() == moment.utc(d).year()) && s.DateEntree)
			) && (
				!this.filterName || this.filterName == "" ||
				(
					(s.FullName && s.FullName.toUpperCase().includes(this.filterName.toUpperCase())) ||
					(s.Numero && s.Numero.toString().toUpperCase().includes(this.filterName.toUpperCase())) ||
					(s.NumeroContrat && s.NumeroContrat.toString().toUpperCase().includes(this.filterName.toUpperCase()))
				)
			)
		);

    	this.doOrder();
	}

	public openSalarie(idSalarie: string, titre: string): void {
    	EventBus.NavigateTo({ path: "/ficheSalarie/" + idSalarie, query: { titre: titre } });
	}

	public getClassOfOrder(columnName: string, desc: boolean): string {
    	if (columnName == this.curentOrberColumn && this.orderingDesc == desc) {
    		return "active";
    	}

    	return "";
	}

	public randomColor(color: string): string {
    	const r = () => Math.floor(256 * Math.random());

    	return this.colorCache[color] || (this.colorCache[color] = `rgb(${r()}, ${r()}, ${r()})`);
	}

	public formatPhoneNumber(number: any): any {
    	if (number == undefined || number == null || number == "") {
			return "";
		}

    	if (number.indexOf(" ") >= 0) {
    		return number;
    	} else {
			return number.toString().match(/.{2}/g).join(" ");
		}
	}

	public changeSize(): void {
    	const popUp = (this.$refs.refModalFilterListeSalaries as ModalFilterListeSalaries);
    	if (popUp != undefined) {
    		this.NomNaissanceVisible = popUp.NomNaissanceVisible;
    		this.QualificationVisible = popUp.QualificationVisible;
    		this.DateEntreeVisible = popUp.DateEntreeVisible;
    		this.DateDebutContratVisible = popUp.DateDebutContratVisible;
    		this.DateDepartVisible = popUp.DateDepartVisible;
    		this.DateFinContratVisible = popUp.DateFinContratVisible;
    		this.TypeContratVisible = popUp.TypeContratVisible;
    		this.RegimeVisible = popUp.RegimeVisible;
    		this.BulletinParMailVisible = popUp.BulletinParMailVisible;
    		this.NatureContratVisible = popUp.NatureContratVisible;
    		this.RemunerationVisible = popUp.RemunerationVisible;
    		this.CongesVisible = popUp.CongesVisible;
    		this.ConventionCollectiveVisible = popUp.ConventionCollectiveVisible;
    		this.TempsTravailVisible = popUp.TempsTravailVisible;
    		this.MutuelleVisible = popUp.MutuelleVisible;
    		this.ModeReglementVisible = popUp.ModeReglementVisible;
    		this.ResponsableHierarchiqueVisible = popUp.ResponsableHierarchiqueVisible;

			this.LibelleEmploiVisible = popUp.LibelleEmploiVisible;
			this.DateFinPeriodeEssaiVisible = popUp.DateFinPeriodeEssaiVisible;
			this.DateFinPrevisionnelleCddVisible = popUp.DateFinPrevisionnelleCddVisible;
			this.DateEntreeProfessionVisible = popUp.DateEntreeProfessionVisible;
			this.ServiceVisible = popUp.ServiceVisible;
			this.DateNaissanceVisible = popUp.DateNaissanceVisible;
    	}

    	let totalColumnSize = 0;
    	if (this.NomNaissanceVisible) {
			totalColumnSize += 200;
		}

		if (this.ServiceVisible) {
			totalColumnSize += 200;
		}

		if (this.LibelleEmploiVisible) {
			totalColumnSize += 200;
		}

		if (this.DateFinPeriodeEssaiVisible) {
			totalColumnSize += 125;
		}

		if (this.DateFinPrevisionnelleCddVisible) {
			totalColumnSize += 125;
		}

		if (this.DateEntreeProfessionVisible) {
			totalColumnSize += 125;
		}

    	if (this.QualificationVisible) {
			totalColumnSize += 150;
		}

    	if (this.DateEntreeVisible) {
			totalColumnSize += 125;
		}

    	if (this.DateDebutContratVisible) {
			totalColumnSize += 125;
		}

    	if (this.DateDepartVisible) {
			totalColumnSize += 125;
		}

    	if (this.DateFinContratVisible) {
			totalColumnSize += 125;
		}

    	if (this.TypeContratVisible) {
			totalColumnSize += 175;
		}

    	if (this.RegimeVisible) {
			totalColumnSize += 175;
		}

    	if (this.BulletinParMailVisible) {
			totalColumnSize += 140;
		}

    	if (this.NatureContratVisible) {
			totalColumnSize += 175;
		}

    	if (this.RemunerationVisible) {
			totalColumnSize += 175;
		}

    	if (this.CongesVisible) {
			totalColumnSize += 175;
		}

    	if (this.ConventionCollectiveVisible) {
			totalColumnSize += 300;
		}

    	if (this.TempsTravailVisible) {
			totalColumnSize += 175;
		}

    	if (this.MutuelleVisible) {
			totalColumnSize += 175;
		}

    	if (this.ModeReglementVisible) {
			totalColumnSize += 175;
		}

    	if (this.ResponsableHierarchiqueVisible) {
			totalColumnSize += 175;
		}

		if (this.DateNaissanceVisible) {
			totalColumnSize += 125;
		}

    	this.totalSize = totalColumnSize;
    	this.saveProfilUtilisateur();
	}

	public getSizeColName(): any {
    	return { width: "calc(100% - " + this.totalSize + "px)" };
	}

	public initTotalSize(): void {
    	if (this.NomNaissanceVisible) {
			this.totalSize += 200;
		}
		if (this.ServiceVisible) {
			this.totalSize += 200;
		}
		if (this.LibelleEmploiVisible) {
			this.totalSize += 200;
		}
		if (this.DateFinPeriodeEssaiVisible) {
			this.totalSize += 125;
		}
		if (this.DateFinPrevisionnelleCddVisible) {
			this.totalSize += 125;
		}
		if (this.DateEntreeProfessionVisible) {
			this.totalSize += 125;
		}
    	if (this.QualificationVisible) {
			this.totalSize += 150;
		}
    	if (this.DateEntreeVisible) {
			this.totalSize += 125;
		}
    	if (this.DateDebutContratVisible) {
			this.totalSize += 125;
		}
    	if (this.DateDepartVisible) {
			this.totalSize += 125;
		}
    	if (this.DateFinContratVisible) {
			this.totalSize += 125;
		}
    	if (this.TypeContratVisible) {
			this.totalSize += 175;
		}
    	if (this.RegimeVisible) {
			this.totalSize += 175;
		}
    	if (this.BulletinParMailVisible) {
			this.totalSize += 140;
		}
    	if (this.NatureContratVisible) {
			this.totalSize += 175;
		}
    	if (this.RemunerationVisible) {
			this.totalSize += 175;
		}
    	if (this.CongesVisible) {
			this.totalSize += 175;
		}
    	if (this.ConventionCollectiveVisible) {
			this.totalSize += 300;
		}
    	if (this.TempsTravailVisible) {
			this.totalSize += 175;
		}
    	if (this.MutuelleVisible) {
			this.totalSize += 175;
		}
    	if (this.ModeReglementVisible) {
			this.totalSize += 175;
		}
    	if (this.ResponsableHierarchiqueVisible) {
			this.totalSize += 175;
		}
		if (this.DateNaissanceVisible) {
			this.totalSize += 125;
		}

    	this.initPopUp();
    	this.changeSize();
	}

	public isFinContrat(salarie: SalarieDto): boolean {
    	if (salarie != undefined &&
            salarie.DateFinContrat != undefined &&
            ParametresInstance.societeCourante != undefined &&
            ParametresInstance.societeCourante.DernierExercice != undefined) {
			return moment.utc(salarie.DateFinContrat).isBefore(ParametresInstance.societeCourante.DernierExercice);
    	}

    	return false;
	}

	public initPopUp(): void {
    	const popUp = (this.$refs.refModalFilterListeSalaries as ModalFilterListeSalaries);
    	if (popUp != undefined) {
    		popUp.NomNaissanceVisible = this.NomNaissanceVisible;
    		popUp.QualificationVisible = this.QualificationVisible;
    		popUp.DateEntreeVisible = this.DateEntreeVisible;
    		popUp.DateDebutContratVisible = this.DateDebutContratVisible;
    		popUp.DateDepartVisible = this.DateDepartVisible;
    		popUp.DateFinContratVisible = this.DateFinContratVisible;
    		popUp.TypeContratVisible = this.TypeContratVisible;
    		popUp.RegimeVisible = this.RegimeVisible;
    		popUp.BulletinParMailVisible = this.BulletinParMailVisible;
    		popUp.BulletinParMailVisible = this.BulletinParMailVisible;
    		popUp.NatureContratVisible = this.NatureContratVisible;
    		popUp.RemunerationVisible = this.RemunerationVisible;
    		popUp.CongesVisible = this.CongesVisible;
    		popUp.ConventionCollectiveVisible = this.ConventionCollectiveVisible;
    		popUp.TempsTravailVisible = this.TempsTravailVisible;
    		popUp.MutuelleVisible = this.MutuelleVisible;
    		popUp.ModeReglementVisible = this.ModeReglementVisible;
    		popUp.ResponsableHierarchiqueVisible = this.ResponsableHierarchiqueVisible;
			popUp.ServiceVisible = this.ServiceVisible;
			popUp.LibelleEmploiVisible = this.LibelleEmploiVisible;
			popUp.DateFinPeriodeEssaiVisible = this.DateFinPeriodeEssaiVisible;
			popUp.DateFinPrevisionnelleCddVisible = this.DateFinPrevisionnelleCddVisible;
			popUp.DateEntreeProfessionVisible = this.DateEntreeProfessionVisible;
			popUp.DateNaissanceVisible = this.DateNaissanceVisible;
    	}
	}

	public openModalFilterListeSalaries(): void {
    	this.initPopUp();
    	$("#modalFilterListeSalaries").modal("show");
	}

	public addDsn(): void {
    	EventBus.NavigateTo({ path: "/contratAutoFromDsn" });
	}

	public exporter(): void {
		NotificationServiceInstance.SendSuccess("La demande d'édition a été prise en compte. Le document sera bientôt disponible");

		const demande = this.createDemande();

		ServicesFactoryInstance.SalarieService.exportListSalariesExcel(demande, (r: Blob) => {
			const libelle = "listeSalaries.xlsx";

			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(r, libelle);
				this.dataReady = true;
			} else {
				this.dataReady = true;

				const link = document.createElement("a");
				document.body.appendChild(link);

				link.href = window.URL.createObjectURL(r);
				link.download = libelle;
				link.click();

				NotificationServiceInstance.SendSuccess("L'édition s'est correctement déroulée !");
			}
		});
	}

	public telecharger(): void {
    	NotificationServiceInstance.SendSuccess("La demande d'édition a été prise en compte. Le document sera bientôt disponible");

		const demande = this.createDemande();

    	ServicesFactoryInstance.EditionsService.getEditionListeSalaries(demande, (r: Blob) => {
    		const libelle = "ListeSalaries.pdf";

    		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    			window.navigator.msSaveOrOpenBlob(r, libelle);
    			this.dataReady = true;
    		} else {
    			this.dataReady = true;

    			const link = document.createElement("a");
    			document.body.appendChild(link);

    			link.href = window.URL.createObjectURL(r);
    			link.download = libelle;
    			link.click();

    			NotificationServiceInstance.SendSuccess("L'édition de la liste des salariés s'est correctement déroulée !");
    		}
    	});
	}

	private createDemande(): CommandeEditionListeSalariesDto {
		let idSociete = 0;

		if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Id != undefined) {
			idSociete = ParametresInstance.societeCourante.Id;
		}

		let filtreContratSalarie: FiltreContratSalarieEnum = FiltreContratSalarieEnum.EnCours;
		if (this.filtreTypeContrat == "ActifExercice") {
			filtreContratSalarie = FiltreContratSalarieEnum.ActifExercice;
		} else if (this.filtreTypeContrat == "Tous") {
			filtreContratSalarie = FiltreContratSalarieEnum.Tous;
		}

		let utilisateurConnecte = "";
		if (ParametresInstance.utilisateurCourant != undefined && ParametresInstance.utilisateurCourant.Intitule != undefined) {
			utilisateurConnecte = ParametresInstance.utilisateurCourant.Intitule;
		}

		const popUpFiltreColonnes = (this.$refs.refModalFilterListeSalaries as ModalFilterListeSalaries);

		const demande: CommandeEditionListeSalariesDto = {
			IdSociete: idSociete,
			UtilisateurConnecte: utilisateurConnecte,
			FiltreContratSalarie: filtreContratSalarie,
			TriListeSalaries: this.getColonneTriee(),
			EstNumeroSalarieVisible: true,
			EstNumeroContratVisible: true,
			EstCiviliteVisible: true,
			EstNomPrenomVisible: true,
			EstNomNaissanceVisible: popUpFiltreColonnes.NomNaissanceVisible,
			EstQualificationVisible: popUpFiltreColonnes.QualificationVisible,
			EstDateEntreeVisible: popUpFiltreColonnes.DateEntreeVisible,
			EstDateDebutContratVisible: popUpFiltreColonnes.DateDebutContratVisible,
			EstDateDepartVisible: popUpFiltreColonnes.DateDepartVisible,
			EstDateFinContratVisible: popUpFiltreColonnes.DateFinContratVisible,
			EstTypeContratVisible: popUpFiltreColonnes.TypeContratVisible,
			EstRegimeVisible: popUpFiltreColonnes.RegimeVisible,
			EstBulletinParMailVisible: popUpFiltreColonnes.BulletinParMailVisible,
			EstNatureContratVisible: popUpFiltreColonnes.NatureContratVisible,
			EstRemunerationVisible: popUpFiltreColonnes.RemunerationVisible,
			EstCongesVisible: popUpFiltreColonnes.CongesVisible,
			EstConventionCollectiveVisible: popUpFiltreColonnes.ConventionCollectiveVisible,
			EstTempsTravailVisible: popUpFiltreColonnes.TempsTravailVisible,
			EstMutuelleVisible: popUpFiltreColonnes.MutuelleVisible,
			EstModeReglementVisible: popUpFiltreColonnes.ModeReglementVisible,
			EstResponsableHierarchiqueVisible: popUpFiltreColonnes.ResponsableHierarchiqueVisible,
			EstServiceVisible: popUpFiltreColonnes.ServiceVisible,
			EstLibelleEmploiVisible: popUpFiltreColonnes.LibelleEmploiVisible,
			EstDateFinPeriodeEssaiVisible: popUpFiltreColonnes.DateFinPeriodeEssaiVisible,
			EstDateFinPrevisionnelleCddVisible: popUpFiltreColonnes.DateFinPrevisionnelleCddVisible,
			EstDateEntreeProfessionVisible: popUpFiltreColonnes.DateEntreeProfessionVisible,
			EstDateNaissanceVisible: popUpFiltreColonnes.DateNaissanceVisible
		};

		return demande;
	}

	public getColonneTriee(): TriListeSalariesEnum {
		if (this.curentOrberColumn == "Numero" && !this.orderingDesc) {
			return TriListeSalariesEnum.NumeroSalarieDecroissant;
		}
    	if (this.curentOrberColumn == "Numero" && this.orderingDesc) {
			return TriListeSalariesEnum.NumeroSalarieCroissant;
		}
    	if (this.curentOrberColumn == "NumeroContrat" && !this.orderingDesc) {
			return TriListeSalariesEnum.NumeroContratDecroissant;
		}
    	if (this.curentOrberColumn == "NumeroContrat" && this.orderingDesc) {
			return TriListeSalariesEnum.NumeroContratCroissant;
		}
    	if (this.curentOrberColumn == "Civilite" && !this.orderingDesc) {
			return TriListeSalariesEnum.CiviliteDecroissant;
		}
    	if (this.curentOrberColumn == "Civilite" && this.orderingDesc) {
			return TriListeSalariesEnum.CiviliteCroissant;
		}
    	if (this.curentOrberColumn == "FullName" && !this.orderingDesc) {
			return TriListeSalariesEnum.NomPrenomDecroissant;
		}
    	if (this.curentOrberColumn == "FullName" && this.orderingDesc) {
			return TriListeSalariesEnum.NomPrenomCroissant;
		}
    	if (this.curentOrberColumn == "NomNaissance" && !this.orderingDesc) {
			return TriListeSalariesEnum.NomNaissanceDecroissant;
		}
    	if (this.curentOrberColumn == "NomNaissance" && this.orderingDesc) {
			return TriListeSalariesEnum.NomNaissanceCroissant;
		}
    	if (this.curentOrberColumn == "Qualification" && !this.orderingDesc) {
			return TriListeSalariesEnum.QualificationDecroissant;
		}
    	if (this.curentOrberColumn == "Qualification" && this.orderingDesc) {
			return TriListeSalariesEnum.QualificationCroissant;
		}
    	if (this.curentOrberColumn == "DateEntree" && !this.orderingDesc) {
			return TriListeSalariesEnum.DateEntreeDecroissant;
		}
    	if (this.curentOrberColumn == "DateEntree" && this.orderingDesc) {
			return TriListeSalariesEnum.DateEntreeCroissant;
		}
    	if (this.curentOrberColumn == "DateDebutContrat" && !this.orderingDesc) {
			return TriListeSalariesEnum.DateDebutContratDecroissant;
		}
    	if (this.curentOrberColumn == "DateDebutContrat" && this.orderingDesc) {
			return TriListeSalariesEnum.DateDebutContratCroissant;
		}
    	if (this.curentOrberColumn == "DateDepart" && !this.orderingDesc) {
			return TriListeSalariesEnum.DateDepartDecroissant;
		}
    	if (this.curentOrberColumn == "DateDepart" && this.orderingDesc) {
			return TriListeSalariesEnum.DateDepartCroissant;
		}
    	if (this.curentOrberColumn == "DateFinContrat" && !this.orderingDesc) {
			return TriListeSalariesEnum.DateFinContratDecroissant;
		}
    	if (this.curentOrberColumn == "DateFinContrat" && this.orderingDesc) {
			return TriListeSalariesEnum.DateFinContratCroissant;
		}
    	if (this.curentOrberColumn == "TypeContrat" && !this.orderingDesc) {
			return TriListeSalariesEnum.TypeContratDecroissant;
		}
    	if (this.curentOrberColumn == "TypeContrat" && this.orderingDesc) {
			return TriListeSalariesEnum.TypeContratCroissant;
		}
    	if (this.curentOrberColumn == "Regime" && !this.orderingDesc) {
			return TriListeSalariesEnum.RegimeDecroissant;
		}
    	if (this.curentOrberColumn == "Regime" && this.orderingDesc) {
			return TriListeSalariesEnum.RegimeCroissant;
		}
    	if (this.curentOrberColumn == "BulletinParMail" && !this.orderingDesc) {
			return TriListeSalariesEnum.BulletinParMailDecroissant;
		}
    	if (this.curentOrberColumn == "BulletinParMail" && this.orderingDesc) {
			return TriListeSalariesEnum.BulletinParMailCroissant;
		}
    	if (this.curentOrberColumn == "NatureContrat" && !this.orderingDesc) {
			return TriListeSalariesEnum.NatureContratDecroissant;
		}
    	if (this.curentOrberColumn == "NatureContrat" && this.orderingDesc) {
			return TriListeSalariesEnum.NatureContratCroissant;
		}
    	if (this.curentOrberColumn == "Remuneration" && !this.orderingDesc) {
			return TriListeSalariesEnum.RemunerationDecroissant;
		}
    	if (this.curentOrberColumn == "Remuneration" && this.orderingDesc) {
			return TriListeSalariesEnum.RemunerationCroissant;
		}
    	if (this.curentOrberColumn == "Conges" && !this.orderingDesc) {
			return TriListeSalariesEnum.CongesDecroissant;
		}
    	if (this.curentOrberColumn == "Conges" && this.orderingDesc) {
			return TriListeSalariesEnum.CongesCroissant;
		}
    	if (this.curentOrberColumn == "ConventionCollective" && !this.orderingDesc) {
			return TriListeSalariesEnum.ConventionCollectiveDecroissant;
		}
    	if (this.curentOrberColumn == "ConventionCollective" && this.orderingDesc) {
			return TriListeSalariesEnum.ConventionCollectiveCroissant;
		}
    	if (this.curentOrberColumn == "TempsTravail" && !this.orderingDesc) {
			return TriListeSalariesEnum.TempsTravailDecroissant;
		}
    	if (this.curentOrberColumn == "TempsTravail" && this.orderingDesc) {
			return TriListeSalariesEnum.TempsTravailCroissant;
		}
    	if (this.curentOrberColumn == "Mutuelle" && !this.orderingDesc) {
			return TriListeSalariesEnum.MutuelleDecroissant;
		}
    	if (this.curentOrberColumn == "Mutuelle" && this.orderingDesc) {
			return TriListeSalariesEnum.MutuelleCroissant;
		}
    	if (this.curentOrberColumn == "ModeReglement" && !this.orderingDesc) {
			return TriListeSalariesEnum.ModeReglementDecroissant;
		}
    	if (this.curentOrberColumn == "ModeReglement" && this.orderingDesc) {
			return TriListeSalariesEnum.ModeReglementCroissant;
		}
    	if (this.curentOrberColumn == "ResponsableHierarchique" && !this.orderingDesc) {
			return TriListeSalariesEnum.ResponsableHierarchiqueDecroissant;
		}
    	if (this.curentOrberColumn == "ResponsableHierarchique" && this.orderingDesc) {
			return TriListeSalariesEnum.ResponsableHierarchiqueCroissant;
		}
		if (this.curentOrberColumn == "LibelleEmploi" && this.orderingDesc) {
			return TriListeSalariesEnum.LibelleEmploiCroissant;
		}
		if (this.curentOrberColumn == "LibelleEmploi" && !this.orderingDesc) {
			return TriListeSalariesEnum.LibelleEmploiDecroissant;
		}
		if (this.curentOrberColumn == "DateFinPeriodeEssai" && this.orderingDesc) {
			return TriListeSalariesEnum.DateFinPeriodeEssaiCroissant;
		}
		if (this.curentOrberColumn == "DateFinPeriodeEssai" && !this.orderingDesc) {
			return TriListeSalariesEnum.DateFinPeriodeEssaiDecroissant;
		}
		if (this.curentOrberColumn == "DateFinPrevisionnelleCdd" && this.orderingDesc) {
			return TriListeSalariesEnum.DateFinPrevisionnelleCddCroissant;
		}
		if (this.curentOrberColumn == "DateFinPrevisionnelleCdd" && !this.orderingDesc) {
			return TriListeSalariesEnum.DateFinPrevisionnelleCddDecroissant;
		}
		if (this.curentOrberColumn == "DateEntreeProfession" && this.orderingDesc) {
			return TriListeSalariesEnum.DateEntreeProfessionCroissant;
		}
		if (this.curentOrberColumn == "DateEntreeProfession" && !this.orderingDesc) {
			return TriListeSalariesEnum.DateEntreeProfessionDecroissant;
		}
		if (this.curentOrberColumn == "Service" && this.orderingDesc) {
			return TriListeSalariesEnum.ServiceCroissant;
		}
		if (this.curentOrberColumn == "Service" && !this.orderingDesc) {
			return TriListeSalariesEnum.ServiceDecroissant;
		}
		if (this.curentOrberColumn == "DateNaissance" && this.orderingDesc) {
			return TriListeSalariesEnum.DateNaissanceCroissant;
		}
		if (this.curentOrberColumn == "DateNaissance" && !this.orderingDesc) {
			return TriListeSalariesEnum.DateNaissanceDecroissant;
		}

    	return TriListeSalariesEnum.NomPrenomDecroissant;
	}
}



// WEBPACK FOOTER //
// ./src/components/salaries/listeSalaries.ts